import React, { FC } from 'react';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import OperatorPanelButton from '@components/operatorPanel/components/elements/buttons/OperatorPanelButton';
import { getHomePageNCFileButtonsCommonStyle } from '@components/operatorPanel/constants/operatorPanel.constants';
import { PanelProps } from '@components/operatorPanel/components/panel';

export interface ViewNCFileButtonProps extends Pick<PanelProps, 'CC' | 'scale' | 'font'> {
  onPress: () => void;
}

const ViewNCFileButton: FC<ViewNCFileButtonProps> = ({ onPress, CC, scale = initialScale, font = initialFont }) => (
  <OperatorPanelButton
    {...getHomePageNCFileButtonsCommonStyle(scale)}
    onPress={onPress}
    CC={CC}
    scale={scale}
    font={font}
    text="View NC File"
    textColor="Label/Light/AlwaysLight Primary"
    customButtonBgColor="Button/Light/Operator Panel [Not Productive]"
  />
);

export default ViewNCFileButton;
